import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  BsSearch,
  BsFillGridFill,
  BsGear,
  BsArrowBarRight,
  BsFillPersonLinesFill,
  BsShield,
  BsUniversalAccess,
  BsLink45Deg,
  BsFileText,
  BsList,
} from "react-icons/bs";
import { useAuthContext } from "../../../../context/AuthContext";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Nav } from "react-bootstrap";
import Logo from "../../../../assets/images/Logo.ico";

const Sidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  setIsCollapsed,
  isMobile,
  isCollapsed,
}) => {
  const location = useLocation();
  const MySwal = swalWithBootstrapButtons(Swal);
  const { signOut, userDetails } = useAuthContext();
  const loggedinUserDetails = JSON.parse(userDetails || "{}");
  const firm_details = loggedinUserDetails?.firm_details || {};
  const user_slug = loggedinUserDetails?.user_slug;
  const firmType = firm_details?.firm_type;
  const user_primary_role = loggedinUserDetails?.user_primary_role;

  const isActive = (path) => location.pathname === path;

  const displayLogoutAlert = () => {
    MySwal.fire({
      title: "Are you sure?",
      text: "that you want to logout from your account",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, logout!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then((result) => {
      if (result.isConfirmed) signOut();
    });
  };

  const isPathActive = (paths) => {
    if (!Array.isArray(paths)) paths = [paths];
    return paths.some((p) => location.pathname.includes(p));
  };

  const handleLinkClick = () => {
    if (isMobile) setIsSidebarOpen(false);
  };

  const sidebarClass = `sidebar ${isMobile && isSidebarOpen ? "open" : ""} ${
    !isMobile && isCollapsed ? "collapsed" : ""
  }`;

  return (
    <>
      {isMobile ? (
        <div
          onClick={() => {
            if (isMobile) {
              setIsSidebarOpen((prev) => !prev);
            } else {
              setIsCollapsed((prev) => !prev);
            }
          }}
          style={{ cursor: "pointer", zIndex: 999 }}
          className="ms-4 mt-4 d-flex align-items-center"
        >
          <BsList size={30} color="black" />
        </div>
      ) : null}

      {/* Sidebar */}
      <div className={sidebarClass}>
        <Nav className="position-relative h-100">
          <div className="flex-grow-1 gy-2">
            <div className={`nav-item d-flex align-items-center p-3`}>
              <div
                onClick={() => {
                  if (isMobile) {
                    setIsSidebarOpen((prev) => !prev);
                  } else {
                    setIsCollapsed((prev) => !prev);
                  }
                }}
                style={{ cursor: "pointer", zIndex: 999 }}
                className="me-4 d-flex align-items-center"
              >
                <img
                  src={Logo}
                  alt="Logo"
                  style={{ maxHeight: "40px", objectFit: "contain" }}
                />
              </div>
            </div>
            {user_primary_role === "3" ? (
              <Link
                to="/dashboard"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isActive("/dashboard") ? "active" : ""
                }`}
              >
                <BsUniversalAccess size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">My Profile</span>
                )}
              </Link>
            ) : (
              <Link
                to="/dashboard"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isActive("/dashboard") ? "active" : ""
                }`}
              >
                <BsFillGridFill size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Dashboard</span>
                )}
              </Link>
            )}

            {(user_primary_role === "1" ||
              user_primary_role === "2" ||
              user_primary_role === "4" ||
              (user_primary_role === "3" && firmType === "1")) && (
              <Link
                to="/search-v2"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isActive("/search-v2") ? "active" : ""
                }`}
              >
                <BsSearch size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Search</span>
                )}
              </Link>
            )}

            {(user_primary_role === "1" || user_primary_role === "2") && (
              <Link
                to={firmType === "1" ? "/my-team" : "/resources"}
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive(["/my-team", "/resources"]) ? "active" : ""
                }`}
              >
                <BsFillPersonLinesFill size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">
                    {firmType === "1" ? "My Team" : "My Candidates"}
                  </span>
                )}
              </Link>
            )}

            {user_primary_role === "1" && (
              <Link
                to="/resource-managers"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive(["resource-manager", "add-resource-manager"])
                    ? "active"
                    : ""
                }`}
              >
                <BsShield size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Resource Managers</span>
                )}
              </Link>
            )}

            {user_primary_role === "2" && firmType === "1" && (
              <Link
                to={`/my-resource-profile/details/${user_slug}`}
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive("/my-resource-profile") ? "active" : ""
                }`}
              >
                <BsUniversalAccess size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">My Profile</span>
                )}
              </Link>
            )}

            {user_primary_role === "2" && (
              <Link
                to="/access-control"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive(["access-control", "add-client"]) ? "active" : ""
                }`}
              >
                <BsLink45Deg size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Access Control</span>
                )}
              </Link>
            )}

            {user_primary_role !== "3" && (
              <Link
                to="/job/latest-jobs"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive("job") ? "active" : ""
                }`}
              >
                <BsFileText size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Latest Jobs</span>
                )}
              </Link>
            )}

            {user_primary_role !== "3" && (
              <Link
                to="/profile-settings"
                onClick={handleLinkClick}
                className={`nav-item d-flex align-items-center p-3 ${
                  isPathActive(["profile-settings", "edit-profile"])
                    ? "active"
                    : ""
                }`}
              >
                <BsGear size={25} className="icon" />
                {(!isCollapsed || isMobile) && (
                  <span className="fs-6 ms-2">Settings</span>
                )}
              </Link>
            )}
          </div>
          {/* Bottom Logout */}
          <div
            className="position-absolute w-100 bg-dark"
            style={{
              bottom: 0,
            }}
          >
            <div
              className="nav-item d-flex align-items-center text-light p-3"
              style={{ cursor: "pointer" }}
              onClick={displayLogoutAlert}
            >
              <BsArrowBarRight size={25} className="icon" />
              {(!isCollapsed || isMobile) && (
                <span className="fs-6 ms-2">Logout</span>
              )}
            </div>
          </div>
        </Nav>
      </div>
    </>
  );
};

export default Sidebar;
